import {
  AfterViewInit,
  Directive,
  HostBinding,
  HostListener,
  Input,
  Renderer2,
} from '@angular/core';

@Directive({ selector: '[appSidebarToggle]' })
export class SidebarToggleDirective implements AfterViewInit {
  @HostBinding('attr.data-toggle')
  @Input()
  get dataToggle(): string {
    return this.dataToggleValue;
  }
  set dataToggle(value: string) {
    this.dataToggleValue = value;
  }

  @HostBinding('class.ft-toggle-right')
  @Input()
  get toggleRight(): boolean {
    return this.toggleRightValue;
  }
  set toggleRight(value: boolean) {
    this.toggleRightValue = value;
  }

  @HostBinding('class.ft-toggle-left')
  @Input()
  get toggleLeft(): boolean {
    return this.toggleLeftValue;
  }
  set toggleLeft(value: boolean) {
    this.toggleLeftValue = value;
  }

  protected dataToggleValue = 'expanded';
  protected toggleRightValue = true;
  protected toggleLeftValue = false;
  protected $wrapper: Element;
  protected compactMenuCheckbox;

  constructor(private _renderer: Renderer2) {}

  ngAfterViewInit(): void {
    this.$wrapper = document.getElementsByClassName('wrapper')[0];
    this.compactMenuCheckbox = this.$wrapper.querySelector('.cz-compact-menu');
  }

  @HostListener('click', ['$event'])
  onClick(): void {
    if (this.dataToggle === 'expanded') {
      this.dataToggle = 'collapsed';
      this._renderer.addClass(this.$wrapper, 'nav-collapsed');

      if (this.compactMenuCheckbox) {
        this.compactMenuCheckbox.checked = true;
      }
    } else {
      this.dataToggle = 'expanded';
      this._renderer.removeClass(this.$wrapper, 'nav-collapsed');
      this._renderer.removeClass(this.$wrapper, 'menu-collapsed');

      if (this.compactMenuCheckbox) {
        this.compactMenuCheckbox.checked = false;
      }
    }

    this.toggleLeft = !this.toggleLeft;
    this.toggleRight = !this.toggleRight;

    setTimeout((): void => {
      this.fireRefreshEventOnWindow();
    }, 300);
  }

  fireRefreshEventOnWindow = (): void => {
    const evt = document.createEvent('HTMLEvents');
    evt.initEvent('resize', true, false);
    window.dispatchEvent(evt);
  };
}
